import { ScaffolderPage } from '@backstage/plugin-scaffolder';
import scaffolderPluginAlpha from '@backstage/plugin-scaffolder/alpha';
import {
  discoveryApiRef,
  featureFlagsApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import { scmIntegrationsApiRef } from '@backstage/integration-react';
import { scaffolderApiRef } from '@backstage/plugin-scaffolder-react';
import { DisabledTemplateCard } from './DisabledTemplateCard';
import { ToggleableScaffolderClient } from './ToggleableScaffolderClient';

export const scaffolderPluginOverride = scaffolderPluginAlpha.withOverrides({
  extensions: [
    scaffolderPluginAlpha.getExtension('api:scaffolder').override({
      params: defineParams =>
        defineParams({
          api: scaffolderApiRef,
          deps: {
            discoveryApi: discoveryApiRef,
            scmIntegrationsApi: scmIntegrationsApiRef,
            fetchApi: fetchApiRef,
            identityApi: identityApiRef,
            featureFlagsApi: featureFlagsApiRef,
          },
          factory: ({
            discoveryApi,
            scmIntegrationsApi,
            fetchApi,
            identityApi,
            featureFlagsApi,
          }) =>
            new ToggleableScaffolderClient({
              discoveryApi,
              scmIntegrationsApi,
              fetchApi,
              identityApi,
              featureFlagsApi,
            }),
        }),
    }),
    scaffolderPluginAlpha.getExtension('page:scaffolder').override({
      params: {
        path: '/create',
        loader: async () => (
          <ScaffolderPage
            components={{
              TemplateCardComponent: DisabledTemplateCard,
            }}
          />
        ),
      },
    }),
  ],
});
